exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.active[data-v-76806936] {\n  background: var(--primary-color) !important ;\n  font-weight: bold;\n}\n", ""]);

// exports
